/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

const MAX_TABLE_ROWS = 10;

/** A small table from the answer's table block (first 10 rows). */
const AnswerTable = ({ table }) => (
  <Box sx={{ overflowX: 'auto', my: 1.5 }}>
    <Table size="small">
      <TableHead>
        <TableRow>
          {table.columns.map((c) => (
            <TableCell key={c} sx={{ fontWeight: 600 }}>
              {c}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {table.rows.slice(0, MAX_TABLE_ROWS).map((row, r) => (
          // eslint-disable-next-line react/no-array-index-key
          <TableRow key={r}>
            {row.map((cell, c) => (
              // eslint-disable-next-line react/no-array-index-key
              <TableCell key={c}>{String(cell ?? '')}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Box>
);

AnswerTable.propTypes = {
  table: PropTypes.shape({ columns: PropTypes.array, rows: PropTypes.array }).isRequired
};

export default AnswerTable;
